module.exports = __webpack_public_path__ + "resources/icon_44_close_round_white.accc8018288569b7.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_close_round_white.png
// module id = 492
// module chunks = 0 1 2 3 4